export interface Color {
  type: string
  prefix?: string
  value: string
  forceHover?: boolean
  variant?: string
}

const TOKEN_BY_VALUE: Record<string, string> = {
  '50': 'primary/5',
  '100': 'primary/10',
  '800': 'primary'
}

export const getColorClass = (color: Color): string => {
  const { type, value, prefix, variant } = color
  const token = variant ? `${variant}-${value}` : TOKEN_BY_VALUE[value] || 'primary'

  return `${prefix ? `${prefix}:` : ''}${type}-${token}`
}

export const handleInputValue = (event: Event): string => {
  const target = event.target as HTMLInputElement
  return target.value
}
